import React, { FC } from "react"

import { convertStringToKebabCase } from "@utils"

import { CardFragment } from "@components/Card/Card"

type AuthorPageStructuredData = {
  name?: string | null,
  recentPosts?: Array<CardFragment | null> | null,
}

const AuthorPageStructuredData: FC<AuthorPageStructuredData> = ({
  name,
  recentPosts,
}) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        "mainEntity": {
          "@id": convertStringToKebabCase(name || ""),
          "@type": "Person",
          "name": name,
        },
        "hasPart": recentPosts?.map(post => post ? ({
          "@type": "Article",
          "headline": post.title,
          "url": `https://www.helpscout.com${post.permalink}`,
          "datePublished": post.date || (new Date()),
          "author": { "@id": convertStringToKebabCase(name || "") }
        }) : null).filter(p => p)
      })
    }}
  />
)

export default AuthorPageStructuredData
